// src/firebase.ts
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyCN7Rkn8MJ47eYYiQ4KIa6viWLQOMJaPME",
    authDomain: "condo-web-ca41f.firebaseapp.com",
    projectId: "condo-web-ca41f",
    storageBucket: "condo-web-ca41f.firebasestorage.app",
    messagingSenderId: "66782035862",
    appId: "1:66782035862:web:d228d833230f74c0cd27b7",
    measurementId: "G-89112JD7Q0"
  };
  

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { db };
